import React, { useState, useRef } from "react";
import { SelectField, InputField } from "components/FormFields";
import ToggleButton from "components/FormFields/ToggleButton";
import Button from "components/Buttons/Button";
import { TrashIcon, XIcon } from "components/Common/Icons";
import {
  IAdditionalInformationFormProps,
  SelectOption,
} from "containers/OnboardingBusiness/types";
import Render from "components/Common/Render";

// Social Media Platform Icons (fallback SVG paths)
const socialMediaIcons: { [key: string]: string } = {
  amazon:
    "M14.538 18.455c-2.667 1.971-6.538 3.018-9.87 3.018-4.672 0-8.876-1.729-12.057-4.608-.25-.225-.026-.532.273-.357 3.428 1.995 7.667 3.195 12.043 3.195 2.953 0 6.201-.613 9.191-1.881.45-.191.827.295.42.633m1.097-1.252c-.341-.438-2.257-.207-3.116-.104-.262.031-.302-.196-.066-.361 1.527-1.074 4.032-.764 4.324-.404.293.363-.076 2.877-1.513 4.079-.221.185-.431.087-.333-.158.323-.806 1.045-2.614.704-3.052",
  facebook:
    "M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z",
  "google maps":
    "M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z",
  instagram:
    "M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z",
  linkedin:
    "M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z",
  pinterest:
    "M12.017 0C5.396 0 .029 5.367.029 11.987c0 5.079 3.158 9.417 7.618 11.162-.105-.949-.199-2.403.041-3.439.219-.937 1.406-5.957 1.406-5.957s-.359-.72-.359-1.781c0-1.663.967-2.911 2.168-2.911 1.024 0 1.518.769 1.518 1.688 0 1.029-.653 2.567-.992 3.992-.285 1.193.6 2.165 1.775 2.165 2.128 0 3.768-2.245 3.768-5.487 0-2.861-2.063-4.869-5.008-4.869-3.41 0-5.409 2.562-5.409 5.199 0 1.033.394 2.143.889 2.741.099.12.112.225.085.345-.09.375-.293 1.199-.334 1.363-.053.225-.172.271-.401.165-1.495-.69-2.433-2.878-2.433-4.646 0-3.776 2.748-7.252 7.92-7.252 4.158 0 7.392 2.967 7.392 6.923 0 4.135-2.607 7.462-6.233 7.462-1.214 0-2.354-.629-2.758-1.379l-.749 2.848c-.269 1.045-1.004 2.352-1.498 3.146 1.123.345 2.306.535 3.55.535 6.607 0 11.985-5.365 11.985-11.987C23.97 5.39 18.592.026 11.985.026L12.017 0z",
  "trip advisor":
    "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3zm8 0c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3z",
  twitter:
    "M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z",
  yelp:
    "M12.271 17.718c-.07.18-.241.29-.421.29h-4.32c-.24 0-.42-.19-.42-.43v-9.5c0-.24.18-.43.42-.43h4.32c.18 0 .351.11.421.29l2.279 6.01c.12.32-.05.67-.38.78l-1.899.71c-.33.12-.67-.05-.78-.38l-2.279-6.01z M18.5 8.5c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm-1.5 7c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2z",
  youtube:
    "M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z",
  other:
    "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z",
};

const AdditionalInformationForm: React.FC<IAdditionalInformationFormProps> = ({
  values,
  setFieldValue,
  setFieldTouched,
  errors,
  touched,
  categoryOptions,
  businessHours,
  toggleBusinessHour,
  businessHoursTimes,
  setBusinessHoursTimes,
  businessPhones,
  setBusinessPhones,
  socialLinks,
  setSocialLinks,
  externalLinkTypes,
  isLoadingExternalLinks,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [newLink, setNewLink] = useState({ platform: "facebook", url: "" });
  const [isMobile, setIsMobile] = useState(false);
  const timeInputRefs = useRef<Record<string, Record<number, { start?: HTMLInputElement | null; end?: HTMLInputElement | null }>>>({});

  // Detect if mobile view
  React.useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };
    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  // Handle time change for a specific day and slot
  const handleTimeChange = (
    day: string,
    slotIndex: number,
    field: "startTime" | "endTime",
    value: string,
  ) => {
    setBusinessHoursTimes((prev) => {
      const updated = { ...prev };
      updated[day] = [...prev[day]];
      updated[day][slotIndex] = {
        ...updated[day][slotIndex],
        [field]: value,
      };
      return updated;
    });
  };

  // Add a new time slot for a day (max 2)
  const addTimeSlot = (day: string) => {
    setBusinessHoursTimes((prev) => {
      if (prev[day].length < 2) {
        return {
          ...prev,
          [day]: [...prev[day], { startTime: "", endTime: "" }],
        };
      }
      return prev;
    });
  };

  // Remove a time slot for a day
  const removeTimeSlot = (day: string, slotIndex: number) => {
    setBusinessHoursTimes((prev) => {
      const updated = { ...prev };
      updated[day] = prev[day].filter((_, index) => index !== slotIndex);
      // Ensure at least one slot remains
      if (updated[day].length === 0) {
        updated[day] = [{ startTime: "", endTime: "" }];
      }
      return updated;
    });
  };

  // Handle adding a new business phone
  const addBusinessPhone = () => {
    // Allow adding unlimited phone numbers
    setBusinessPhones([...businessPhones, ""]);
  };

  // Handle removing a business phone
  const removeBusinessPhone = (index: number) => {
    if (businessPhones.length > 1) {
      setBusinessPhones(businessPhones.filter((_, i) => i !== index));
    }
  };

  // Handle business phone change
  const handleBusinessPhoneChange = (index: number, value: string) => {
    const updatedPhones = [...businessPhones];
    updatedPhones[index] = value;
    setBusinessPhones(updatedPhones);
  };

  // Get error message for a specific phone index from Formik
  const getPhoneError = (index: number): string | undefined => {
    // Access array field errors from Formik
    if (touched.businessPhones && Array.isArray(errors.businessPhones)) {
      return errors.businessPhones[index] as string | undefined;
    }
    return undefined;
  };

  // Get error message for a specific social link index from Formik
  const getSocialLinkError = (index: number): string | undefined => {
    // Access array field errors from Formik
    if (touched.socialLinks && Array.isArray(errors.socialLinks)) {
      const linkError = errors.socialLinks[index];
      if (linkError && typeof linkError === "object" && "url" in linkError) {
        return (linkError as any).url;
      }
    }
    return undefined;
  };

  // Handle adding a new social link via modal (mobile) or inline (desktop)
  const openAddLinkModal = () => {
    setNewLink({ platform: "facebook", url: "" });
    setIsModalOpen(true);
  };

  const handleAddLink = () => {
    if (newLink.url.trim() && socialLinks.length < 5) {
      setSocialLinks([...socialLinks, { ...newLink }]);
      setIsModalOpen(false);
      setNewLink({ platform: "facebook", url: "" });
    }
  };

  // Handle adding inline link for desktop
  const addSocialLinkInline = () => {
    if (socialLinks.length < 5) {
      setSocialLinks([...socialLinks, { platform: "", url: "" }]);
    }
  };

  // Handle removing a social link
  const removeSocialLink = (index: number) => {
    setSocialLinks(socialLinks.filter((_, i) => i !== index));
  };

  // Handle social link change for desktop inline editing
  const handleSocialLinkChange = (
    index: number,
    field: "platform" | "url",
    value: string,
  ) => {
    const updatedLinks = [...socialLinks];
    updatedLinks[index][field] = value;
    setSocialLinks(updatedLinks);
  };

  // Social Media Platform Options - Dynamic from API (filtered list)
  const platformOptions = React.useMemo(() => {
    if (!externalLinkTypes || externalLinkTypes.length === 0) {
      return [];
    }
    
    // Allowed platforms list (excluding Web and Whatsapp)
    const allowedPlatforms = [
      'amazon',
      'facebook',
      'google maps',
      'instagram',
      'linkedin',
      'pinterest',
      'trip advisor',
      'twitter',
      'yelp',
      'youtube',
      'other',
    ];
    
    return externalLinkTypes
      .filter((type) => allowedPlatforms.includes(type.name.toLowerCase()))
      .map((type) => ({
        value: type.name.toLowerCase(),
        label: type.name,
        uuid: type.metaExternalLinkUuid,
        logo: type.logo,
        isOther: type.isOther,
      }));
  }, [externalLinkTypes]);

  // Get platform icon component (uses API logo or fallback SVG)
  const getPlatformIcon = (platform: string) => {
    // First try to get logo from API
    const platformOption = platformOptions.find(
      (opt) => opt.value === platform.toLowerCase()
    );
    
    if (platformOption && platformOption.logo) {
      return (
        <img
          src={platformOption.logo}
          alt={platformOption.label}
          className="w-5 h-5 object-contain"
          onError={(e) => {
            // If image fails to load, hide it
            e.currentTarget.style.display = 'none';
          }}
        />
      );
    }
    
    // Fallback to SVG icon
    const iconPath = socialMediaIcons[platform.toLowerCase()];
    if (!iconPath) return null;

    return (
      <svg
        className={`w-5 h-5 ${platform === "facebook" ? "text-[#1877F2]" : "text-[#333]"}`}
        viewBox="0 0 24 24"
        fill="currentColor"
      >
        <path d={iconPath} />
      </svg>
    );
  };

  return (
    <div>
      <h2 className="mb-4 sm:mb-6 font-poppins font-semibold text-lg leading-[18px] text-royalPurple">
        Add Additional Information
      </h2>
      <form className="space-y-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          {/* Left Column */}
          <div className="space-y-6">
            <div>
              <label className="block mb-2 font-poppins text-xs font-semibold md:font-normal leading-[12px] text-darkBlack">
                Category
              </label>
              <SelectField<SelectOption>
                getOptionLabel={(option) => option?.name || ""}
                getOptionValue={(option) => option?.value || ""}
                value={values.category}
                isSearchable
                placeholder="Select Category"
                closeMenuOnSelect
                options={categoryOptions}
                onChange={(selectedOption) => {
                  setFieldValue("category", selectedOption);
                }}
                error={(errors.category as any)?.name || ""}
                touched={touched.category}
              />
            </div>
          </div>

          {/* Right Column */}
          <div className="space-y-6">
            <InputField
              label="Website"
              type="text"
              placeholder="Enter Website"
              value={values.website}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                setFieldValue("website", e.target.value)
              }
              error={touched.website && errors.website}
              containerClass="mb-0"
            />
          </div>
        </div>

        {/* Business Phone - Full Width */}
        <div>
          <label className="block mb-2 font-poppins text-xs font-semibold md:font-normal leading-[12px] text-darkBlack">
            Business Phone
          </label>
          <div className="space-y-3">
            {businessPhones.map((phone, index) => {
              const phoneError = getPhoneError(index);
              return (
                <div key={index}>
                  <div className="flex gap-2 items-start">
                    <div className="flex-1">
                      <input
                        type="tel"
                        inputMode="tel"
                        placeholder="Enter phone number"
                        value={phone}
                        onChange={(e) =>
                          handleBusinessPhoneChange(index, e.target.value)
                        }
                        onBlur={() => {
                          // Mark this array field as touched for Formik validation
                          setFieldTouched("businessPhones", true);
                        }}
                        className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 placeholder:text-[#BCBCBF] placeholder:font-normal placeholder:text-sm font-poppins text-base md:text-sm ${
                          phoneError
                            ? "border-red-500 focus:ring-red-500 focus:border-red-500"
                            : "border-gray-300 focus:ring-blue-500 focus:border-blue-500"
                        }`}
                      />
                      <Render when={!!phoneError}>
                        <div className="pt-1 pl-1 text-sm text-red-600">
                          {phoneError}
                        </div>
                      </Render>
                    </div>
                    <Render when={index > 0}>
                      <button
                        type="button"
                        onClick={() => removeBusinessPhone(index)}
                        className="p-2 text-red-500 hover:text-red-700 flex-shrink-0 h-[56px] md:h-[45px] flex items-center justify-center"
                      >
                        <TrashIcon />
                      </button>
                    </Render>
                  </div>
                </div>
              );
            })}
          </div>
          <button
            type="button"
            onClick={addBusinessPhone}
            className="text-blue-600 hover:text-blue-800 text-sm mt-2 flex items-center"
          >
            <div className="w-[14px] h-[14px] rounded-full bg-blue-600 flex items-center justify-center mr-1">
              <svg className="w-2 h-2 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M12 4v16m8-8H4" />
              </svg>
            </div>
            Add business phone
          </button>
        </div>

        {/* External Links - Full Width - Desktop: Inline, Mobile: Modal */}
        <div>
          <label className="block mb-2 font-poppins text-xs font-semibold md:font-normal leading-[12px] text-darkBlack">
            {isMobile ? "External Links" : "Find Us At"}
          </label>

          {/* Desktop View - Inline Form Fields */}
          <div className="hidden md:block">
            <div className="space-y-3">
              {socialLinks.map((link, index) => (
                <div key={index} className="flex gap-3 items-start">
                  {/* Platform Dropdown */}
                  <div className="w-48">
                    <SelectField<{ value: string; label: string }>
                      getOptionLabel={(option) => option?.label || ""}
                      getOptionValue={(option) => option?.value || ""}
                      value={link.platform ? platformOptions.find(opt => opt.value === link.platform) : null}
                      options={platformOptions}
                      onChange={(selectedOption) => {
                        if (selectedOption) {
                          handleSocialLinkChange(index, "platform", selectedOption.value);
                        }
                      }}
                      placeholder="Facebook"
                      closeMenuOnSelect
                    />
                  </div>

                  {/* URL Input with Icon */}
                  <div className="flex-1">
                    <div className="relative">
                      <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                        {getPlatformIcon(link.platform || "facebook")}
                      </div>
                      <input
                        type="text"
                        placeholder={
                          link.platform === "instagram" || link.platform === "twitter"
                            ? "Enter username"
                            : link.platform === "facebook"
                            ? "Enter Facebook URL"
                            : link.platform === "linkedin"
                            ? "Enter LinkedIn URL"
                            : "Enter URL"
                        }
                        value={link.url}
                        onChange={(e) =>
                          handleSocialLinkChange(index, "url", e.target.value)
                        }
                        onBlur={() => {
                          // Mark this array field as touched for Formik validation
                          setFieldTouched("socialLinks", true);
                        }}
                        className={`w-full h-[42px] pl-10 pr-3 py-2 border rounded-md focus:outline-none focus:ring-2 placeholder:text-[#BCBCBF] placeholder:font-poppins placeholder:font-normal placeholder:text-[14px] placeholder:leading-[100%] placeholder:tracking-normal font-poppins text-base md:text-sm ${
                          getSocialLinkError(index)
                            ? "border-red-500 focus:ring-red-500"
                            : "border-gray-300 focus:ring-blue-500"
                        }`}
                      />
                    </div>
                    <Render when={!!getSocialLinkError(index)}>
                      <div className="pt-1 pl-1 text-sm text-red-600">
                        {getSocialLinkError(index)}
                      </div>
                    </Render>
                  </div>

                  {/* Remove Button */}
                  <Render when={index > 0}>
                    <button
                      type="button"
                      onClick={() => removeSocialLink(index)}
                      className="p-2 text-red-500 hover:text-red-700"
                    >
                      <TrashIcon />
                    </button>
                  </Render>
                </div>
              ))}
            </div>
            <Render when={socialLinks.length < 5}>
              <button
                type="button"
                onClick={addSocialLinkInline}
                className="text-blue-600 hover:text-blue-800 text-sm mt-2 flex items-center"
              >
                <div className="w-[14px] h-[14px] rounded-full bg-blue-600 flex items-center justify-center mr-1">
                  <svg className="w-2 h-2 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M12 4v16m8-8H4" />
                  </svg>
                </div>
                Add link
              </button>
            </Render>
          </div>

          {/* Mobile View - Modal Based */}
          <div className="md:hidden">
            <Render
              when={
                socialLinks.length === 0 ||
                (socialLinks.length === 1 && !socialLinks[0].url)
              }
              elseRender={
                <div className="space-y-3">
                  {socialLinks
                    .filter((link) => link.url)
                    .map((link, index) => (
                      <div
                        key={index}
                        className="flex items-center justify-between p-3 border border-gray-200 rounded-lg bg-white"
                      >
                        <div className="flex items-center gap-3 flex-1 min-w-0">
                          {getPlatformIcon(link.platform)}
                          <span className="text-sm text-gray-900 truncate">
                            {link.url}
                          </span>
                        </div>
                        <button
                          type="button"
                          onClick={() =>
                            removeSocialLink(
                              socialLinks.findIndex((l) => l === link),
                            )
                          }
                          className="flex-shrink-0 p-1 text-red-500 hover:text-red-700"
                        >
                          <svg
                            className="w-5 h-5"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                            />
                          </svg>
                        </button>
                      </div>
                    ))}
                  <Render
                    when={socialLinks.filter((link) => link.url).length < 5}
                  >
                    <button
                      type="button"
                      onClick={openAddLinkModal}
                      className="text-blue-600 hover:text-blue-800 text-sm mt-2 flex items-center"
                    >
                      <div className="w-[14px] h-[14px] rounded-full bg-blue-600 flex items-center justify-center mr-1">
                        <svg className="w-2 h-2 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M12 4v16m8-8H4" />
                        </svg>
                      </div>
                      Add link
                    </button>
                  </Render>
                </div>
              }
            >
              <div className="border border-gray-200 rounded-lg p-8 flex flex-col items-center justify-center bg-gray-50">
                <div className="w-16 h-16 rounded-full bg-blue-100 flex items-center justify-center mb-4">
                  <svg
                    className="w-8 h-8 text-blue-600"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1"
                    />
                  </svg>
                </div>
                <p className="text-gray-500 text-sm mb-4">No links added yet</p>
                <button
                  type="button"
                  onClick={openAddLinkModal}
                  className="text-blue-600 hover:text-blue-800 text-sm flex items-center"
                >
                  <div className="w-[14px] h-[14px] rounded-full bg-blue-600 flex items-center justify-center mr-1">
                    <svg className="w-2 h-2 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M12 4v16m8-8H4" />
                    </svg>
                  </div>
                  Add link
                </button>
              </div>
            </Render>
          </div>

          <Render when={!!(touched.findUsAt && errors.findUsAt)}>
            <div className="pt-1 pl-1 text-sm text-red-600">
              {errors.findUsAt}
            </div>
          </Render>
        </div>

        {/* Add Link Modal - Bottom Sheet Style (Mobile Only) */}
        <Render when={isModalOpen && isMobile}>
          <div className="fixed inset-0 z-50 flex items-end justify-center">
            {/* Backdrop */}
            <div
              className="fixed inset-0 bg-black bg-opacity-50 transition-opacity"
              onClick={() => setIsModalOpen(false)}
            ></div>

            {/* Bottom Sheet */}
            <div className="relative w-full bg-white rounded-t-2xl shadow-xl animate-slide-up max-h-[85vh] overflow-y-auto">
              <div className="p-6 space-y-4">
                {/* Modal Header */}
                <div className="flex items-center justify-between pb-4 border-b border-gray-200">
                  <h3 className="text-xl font-semibold text-gray-900">
                    Add Social Profile
                  </h3>
                  <button
                    onClick={() => setIsModalOpen(false)}
                    className="text-gray-400 hover:text-gray-600 transition-colors"
                  >
                    <XIcon className="w-6 h-6" />
                  </button>
                </div>

                {/* Platform Selection */}
                <div>
                  <label className="block mb-2 font-poppins text-xs font-semibold md:font-normal leading-[12px] text-darkBlack">
                    Choose Type
                  </label>
                  <div className="relative">
                    <select
                      value={newLink.platform}
                      onChange={(e) =>
                        setNewLink({ ...newLink, platform: e.target.value })
                      }
                      className="w-full px-4 py-3 pr-10 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 bg-white appearance-none font-poppins text-sm"
                    >
                      {platformOptions.map((option) => (
                        <option key={option.value} value={option.value}>
                          {option.label}
                        </option>
                      ))}
                    </select>
                    <div className="absolute inset-y-0 right-3 flex items-center pointer-events-none">
                      <svg
                        className="w-4 h-4 text-gray-500"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M19 9l-7 7-7-7"
                        />
                      </svg>
                    </div>
                  </div>
                </div>

                {/* URL or Username Input */}
                <div>
                  <label className="block mb-2 font-poppins text-xs font-semibold md:font-normal leading-[12px] text-darkBlack">
                    {newLink.platform === "instagram" || newLink.platform === "twitter" ? "Username" : "URL"}
                  </label>
                  <div className="relative">
                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                      {getPlatformIcon(newLink.platform)}
                    </div>
                    <input
                      type="text"
                      placeholder={
                        newLink.platform === "instagram" || newLink.platform === "twitter"
                          ? "Enter username"
                          : newLink.platform === "facebook"
                          ? "Enter Facebook URL"
                          : newLink.platform === "linkedin"
                          ? "Enter LinkedIn URL"
                          : "Enter URL"
                      }
                      value={newLink.url}
                      onChange={(e) =>
                        setNewLink({ ...newLink, url: e.target.value })
                      }
                      className="w-full pl-10 pr-3 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 placeholder:text-[#BCBCBF] placeholder:font-poppins placeholder:font-normal placeholder:text-[14px] placeholder:leading-[100%] placeholder:tracking-normal font-poppins text-base md:text-sm"
                    />
                  </div>
                </div>

                {/* Add Button */}
                <Button
                  type="button"
                  label="Add"
                  onClick={handleAddLink}
                  disabled={!newLink.url.trim()}
                  variant="primary"
                  customClass="w-full !mb-0 !me-0"
                />
              </div>
            </div>
          </div>
        </Render>

        {/* Business Hours - Full Width */}
        <div className="mt-6">
          <label className="block mb-2 font-poppins text-xs font-semibold md:font-normal leading-[12px] text-darkBlack">
            Business Hours
          </label>
          <div className="border border-gray-300 rounded-lg py-4 px-3 sm:px-5 w-full bg-white">
            <div className="space-y-4">
              {[
                "Monday",
                "Tuesday",
                "Wednesday",
                "Thursday",
                "Friday",
                "Saturday",
                "Sunday",
              ].map((day) => {
                const dayKey = day.toLowerCase();
                const isEnabled = businessHours[dayKey];
                const dayTimes = businessHoursTimes[dayKey] || [];

                return (
                  <div key={day} className="space-y-2">
                    <Render
                      when={isEnabled && dayTimes.length > 0}
                      elseRender={
                        <div className="flex items-center gap-2 sm:gap-4 py-1">
                          {/* Day name - Responsive width */}
                          <div className="w-[80px] sm:w-[100px] font-poppins font-normal text-[15px] leading-[100%] text-darkBlack">
                            {day}
                          </div>
                          {/* Toggle Button */}
                          <div className="flex-shrink-0">
                            <ToggleButton
                              value={isEnabled}
                              onToggle={() => toggleBusinessHour(dayKey)}
                              label=""
                            />
                          </div>
                        </div>
                      }
                    >
                      {dayTimes.map((slot, index) => (
                        <div key={index} className="flex items-center gap-1 sm:gap-4 pr-4 sm:pr-0">
                          {/* Day name and Toggle - Show only for first slot */}
                          <Render when={index === 0}>
                            <div className="w-[80px] sm:w-[100px] font-poppins font-normal text-[15px] leading-[100%] text-darkBlack">
                              {day}
                            </div>
                            <div className="flex-shrink-0">
                              <ToggleButton
                                value={isEnabled}
                                onToggle={() => toggleBusinessHour(dayKey)}
                                label=""
                              />
                            </div>
                          </Render>

                          {/* Empty spacer for subsequent slots */}
                          <Render when={index > 0}>
                            <div className="w-[80px] sm:w-[100px]"></div>
                            <div className="w-[52px]"></div>
                          </Render>

                          {/* Time inputs */}
                          <div className="flex items-center gap-0.5 sm:gap-3 flex-1 sm:flex-initial">
                            <div 
                              className="relative w-[115px] sm:w-[130px]"
                              onClick={() => {
                                // Open time picker when clicking anywhere on the container
                                timeInputRefs.current[dayKey]?.[index]?.start?.showPicker?.();
                              }}
                            >
                              <input
                                ref={(el) => {
                                  if (!timeInputRefs.current[dayKey]) timeInputRefs.current[dayKey] = {};
                                  if (!timeInputRefs.current[dayKey][index]) timeInputRefs.current[dayKey][index] = {};
                                  timeInputRefs.current[dayKey][index].start = el;
                                }}
                                type="time"
                                className={`w-full h-[36px] px-2 sm:px-3 py-2 pr-1 sm:pr-3 border border-[#EDEDF0] rounded bg-white font-poppins text-xs sm:text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 cursor-pointer`}
                                value={slot.startTime || ""}
                                onChange={(e) => {
                                  handleTimeChange(
                                    dayKey,
                                    index,
                                    "startTime",
                                    e.target.value,
                                  );
                                  // Close picker after selection
                                  e.target.blur();
                                }}
                              />
                              {!slot.startTime && (
                                <span className="absolute left-2 sm:left-3 top-1/2 -translate-y-1/2 text-[#BCBCBF] pointer-events-none font-poppins text-[10px] sm:text-xs">
                                  HH:MM
                                </span>
                              )}
                            </div>
                            <span className="text-darkBlack text-xs sm:text-sm flex-shrink-0">-</span>
                            <div 
                              className="relative w-[115px] sm:w-[130px]"
                              onClick={() => {
                                // Open time picker when clicking anywhere on the container
                                timeInputRefs.current[dayKey]?.[index]?.end?.showPicker?.();
                              }}
                            >
                              <input
                                ref={(el) => {
                                  if (!timeInputRefs.current[dayKey]) timeInputRefs.current[dayKey] = {};
                                  if (!timeInputRefs.current[dayKey][index]) timeInputRefs.current[dayKey][index] = {};
                                  timeInputRefs.current[dayKey][index].end = el;
                                }}
                                type="time"
                                className={`w-full h-[36px] px-2 sm:px-3 py-2 pr-1 sm:pr-3 border border-[#EDEDF0] rounded bg-white font-poppins text-xs sm:text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 cursor-pointer`}
                                value={slot.endTime || ""}
                                onChange={(e) => {
                                  handleTimeChange(
                                    dayKey,
                                    index,
                                    "endTime",
                                    e.target.value,
                                  );
                                  // Close picker after selection
                                  e.target.blur();
                                }}
                              />
                              {!slot.endTime && (
                                <span className="absolute left-2 sm:left-3 top-1/2 -translate-y-1/2 text-[#BCBCBF] pointer-events-none font-poppins text-[10px] sm:text-xs">
                                  HH:MM
                                </span>
                              )}
                            </div>
                            
                            {/* Add/Delete buttons */}
                            <Render
                              when={index === 0 && dayTimes.length < 2}
                              elseRender={
                                <Render when={index > 0}>
                                  <button
                                    type="button"
                                    onClick={() =>
                                      removeTimeSlot(dayKey, index)
                                    }
                                    className="text-[#FF6B6B] hover:text-red-700 p-1 flex-shrink-0"
                                    aria-label="Remove time slot"
                                  >
                                    <svg
                                      className="w-5 h-5"
                                      fill="none"
                                      stroke="currentColor"
                                      viewBox="0 0 24 24"
                                    >
                                      <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth={2}
                                        d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                                      />
                                    </svg>
                                  </button>
                                </Render>
                              }
                            >
                              <button
                                type="button"
                                onClick={() => addTimeSlot(dayKey)}
                                className="text-[#4285F4] hover:text-blue-700 p-1 flex-shrink-0"
                                aria-label="Add time slot"
                              >
                                <svg
                                  className="w-5 h-5"
                                  fill="none"
                                  stroke="currentColor"
                                  viewBox="0 0 24 24"
                                >
                                  <circle
                                    cx="12"
                                    cy="12"
                                    r="10"
                                    stroke="currentColor"
                                    strokeWidth="2"
                                  />
                                  <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={2}
                                    d="M12 8v8M8 12h8"
                                  />
                                </svg>
                              </button>
                            </Render>
                          </div>
                        </div>
                      ))}
                    </Render>
                  </div>
                );
              })}
            </div>
          </div>
          {/* Only show validation error if user has enabled days but not filled times */}
          <Render when={!!(touched.businessHours && errors.businessHours && Object.values(businessHours).some((v) => v === true))}>
            <div className="pt-2 pl-1 text-sm text-red-600">
              {errors.businessHours}
            </div>
          </Render>
        </div>

        {/* Business Hours Note */}
        <div className="mt-6">
          <textarea
            rows={1}
            placeholder="Enter business hours note"
            value={values.businessHoursNote}
            onChange={(e) => setFieldValue("businessHoursNote", e.target.value)}
            onBlur={() => setFieldTouched("businessHoursNote", true)}
            className="w-full max-w-[1320px] h-[47px] rounded border border-gray-300 p-3 font-poppins font-normal text-[15px] leading-[100%] tracking-normal placeholder:text-[#BCBCBF] placeholder:font-normal placeholder:text-[15px] placeholder:leading-[100%] focus:outline-none focus:ring-2 focus:ring-blue-500 resize-none"
          />
          {touched.businessHoursNote && errors.businessHoursNote && (
            <div className="pt-1 pl-1 text-sm text-red-600">
              {errors.businessHoursNote}
            </div>
          )}
        </div>
      </form>
    </div>
  );
};

export default AdditionalInformationForm;
